import { useEffect } from "react";

const BASE = "Innovative Fusion Hives";

export default function Seo({ title, description, path = "" }) {
    useEffect(() => {
        document.title = title ? `${title} | ${BASE}` : `${BASE} | Digital Creative Agency in Long Beach, CA`;
        const desc = description || "Full-service digital creative agency in Long Beach, CA: web development, graphic design, social media management, and digital marketing.";
        let meta = document.querySelector('meta[name="description"]');
        if (meta) meta.setAttribute("content", desc);
        let link = document.querySelector('link[rel="canonical"]');
        if (!link) {
            link = document.createElement("link");
            link.setAttribute("rel", "canonical");
            document.head.appendChild(link);
        }
        link.setAttribute("href", `https://innovativefusionhives.com${path}`);
    }, [title, description, path]);
    return null;
}
